module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//27.jpg?998096ca275ed94e4306f602a8ffa5f0";